import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { showPopupParts, setCarSelectedParts } from '../../../../../actions/price'
import { translation } from '../../../../../utils/helpers'

// Elements
import Button from '../../../../elements/button'
import Check from '../../../../elements/check'
import Text from '../../../../elements/text'
import Inline from '../../../../elements/inline'
import Divider from '../../../../elements/divider'

// import styles
// import '../car.scss'
// import './carpopup.scss'

class DeviationList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedPart: {},
      selectedBodyPart: undefined,
      showPopupForParts: this.props.showPopupForParts === true,
      selectedPartsOriginal: [],
      carItems: this.props.carItems,
      carPartItems: []
    }
    this.renderComplaintOrDeviation = this.renderComplaintOrDeviation.bind(this)
    this.setSelectedProp = this.setSelectedProp.bind(this)
    this.close = this.close.bind(this)
    this.getTaskSide = this.getTaskSide.bind(this)
    this.manualTaskId = 9000000000000000
  }
  componentDidMount () {
    this.reset.bind(this)
    this.init(this.props)
  }

  componentWillUnmount () {
    this.reset()
  }

  getTaskSide (key) {
    if (key.indexOf('tag') !== -1) {
      return 0
    }
    if (key.endsWith('-for')) {
      if (key.indexOf('venstre-') !== -1) return 5
      if (key.indexOf('hojre-') !== -1) return 6
    } else if (key.endsWith('-bag')) {
      if (key.indexOf('venstre-') !== -1) return 7
      if (key.indexOf('hojre-') !== -1) return 8
    }

    if (key.indexOf('venstre-') !== -1) {
      return 1
    } else if (key.indexOf('hojre-') !== -1) {
      return 2
    } else if (key.indexOf('for-') !== -1) {
      return 3
    } else if (key.indexOf('bag-') !== -1) {
      return 4
    }
    // console.log(key, ' - no side')
    return 0
  }

  setSelectedProp () {
    let part = this.state.selectedBodyPart
    var partTaskSide = this.getTaskSide(part)
    let carItems = this.state.carItems
    if (window.carHandler.priceCalcType === 5 || window.carHandler.priceCalcType === 10) {
      if (window.carHandler.priceCalcType !== 5 && !(window.carHandler.priceCalcType === 10 && window.carHandler.realOrderType === 5)) {
        let carPartItems = []
        // console.log('carItems', carItems)
        carItems.map((val) => {
          let item = { ...val }
          item.id = part + '_' + item.EnumValue
          item.IsSelected = false
          this.props.price.Parts.map((pricePart) => {
            // console.log('MappingName', pricePart.Part.MappingName, 'TaskSide', partTaskSide, 'pricePart', pricePart)
            if (pricePart.Part.TaskSide === partTaskSide && part.includes(pricePart.Part.MappingName)) {
              pricePart.DeviationReasons.map((reason) => {
                if ('' + reason.DeviationType.Id === '' + item.EnumValue) item.IsSelected = true
              })
            }

            // let indexI = part.indexOf(pricePart.Part.MappingName)
            // let indexV = part.indexOf('venstre-')
            // let indexH = part.indexOf('hojre-')
            // if ((indexI === 0 && pricePart.Part.TaskSide === 0) || (indexI > -1 && (indexV === 0 && pricePart.Part.TaskSide === 1 || indexH === 0 && pricePart.Part.TaskSide === 2))) {
            //   pricePart.DeviationReasons.map((reason) => {
            //     if ('' + reason.DeviationType.Id === '' + item.EnumValue) item.IsSelected = true
            //   })
            // }
          })
          carPartItems.push(item)
        })
        this.props.price.Parts.map((pricePart) => {
          if (pricePart.Part.TaskSide === partTaskSide && part.includes(pricePart.Part.MappingName)) {
            pricePart.CustomDeviationReasons.map((reason) => {
              let customReason = this.getBlankDeviation(part)
              customReason.id = part + '_' + reason.CustomDeviationReasonId
              customReason.IsSelected = true
              customReason.CustomReason = reason.CustomReason
              customReason.IsNew = false
              customReason.name = part + '_' + reason.CustomDeviationReasonId
              customReason.CustomDeviationReasonId = reason.CustomDeviationReasonId
              if (carPartItems.filter((item) => { item.CustomDeviationReasonId === customReason.CustomDeviationReasonId }).length === 0) {
                carPartItems.push(customReason)
              }
            })
          }

          // let indexI = part.indexOf(pricePart.Part.MappingName)
          // let indexV = part.indexOf('venstre-')
          // let indexH = part.indexOf('hojre-')
          // if ((indexI === 0 && pricePart.Part.TaskSide === 0) ||
          //   (indexI > -1 && (indexV === 0 && pricePart.Part.TaskSide === 1 || indexH === 0 && pricePart.Part.TaskSide === 2))) {
          //   pricePart.CustomDeviationReasons.map((reason) => {
          //     let customReason = this.getBlankDeviation(part)
          //     customReason.id = part + '_' + reason.CustomDeviationReasonId
          //     customReason.IsSelected = true
          //     customReason.CustomReason = reason.CustomReason
          //     customReason.IsNew = false
          //     customReason.name = part + '_' + reason.CustomDeviationReasonId
          //     customReason.CustomDeviationReasonId = reason.CustomDeviationReasonId
          //     if (carPartItems.filter((item) => { item.CustomDeviationReasonId === customReason.CustomDeviationReasonId }).length === 0) carPartItems.push(customReason)
          //   })
          // }
        })
        carPartItems.push(this.getBlankDeviation(part))
        this.setState({
          carPartItems: carPartItems
        })
      } else {
        let carPartItems = []
        carItems.map((val) => {
          let item = { ...val }
          item.id = part + '_' + item.EnumValue
          item.IsSelected = false
          this.props.price.Parts.map((pricePart) => {
            let indexI = part.indexOf(pricePart.Part.MappingName)
            let indexV = part.indexOf('venstre-')
            let indexH = part.indexOf('hojre-')
            if ((indexI === 0 && pricePart.Part.TaskSide === 0) ||
              (indexI > -1 && (indexV === 0 && pricePart.Part.TaskSide === 1 || indexH === 0 && pricePart.Part.TaskSide === 2))) {
              pricePart.Complaints.map((reason) => {
                if ('' + reason.ComplaintType === '' + item.EnumValue) item.IsSelected = true
              })
            }
          })
          carPartItems.push(item)
        })
        this.setState({
          carPartItems: carPartItems
        })
      }
    }
    return carItems
  }
  getBlankDeviation (part) {
    this.manualTaskId++
    return {
      id: part + '_' + this.manualTaskId,
      EnumValue: '',
      IsSelected: false,
      name: '',
      IsNew: true,
      IsCustomDeviation: true
    }
  }
  reset (props) {
    this.manualTaskId = 9000000000000000
    this.setState({
      selectedParts: [],
      inputs: [],
      inputsOriginal: [],
      carParts: [],
      priceParts: [],
      selectedPart: {},
      selectedBodyPart: typeof (props) === 'undefined' ? undefined : props.selectedBodyPart,
      showPopupForParts: typeof (props) === 'undefined' ? false : props.showPopupForParts === true,
      selectedPartsOriginal: [],
      carItems: typeof (props) === 'undefined' ? [] : props.carItems,
      carPartItems: []
    })
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.showPopupForParts !== nextProps.showPopupForParts ||
      this.props.selectedBodyPart !== nextProps.selectedBodyPart ||
      this.props.selectedBodyPartSide !== nextProps.selectedBodyPartSide || !isEqual(nextProps.carItems, this.props.carItems)) {
      if (nextProps.showPopupForParts) {
        this.init(nextProps)
      } else {
        this.reset(nextProps)
      }
    }
  }
  init (props) {
    this.reset(props)
    if (props.showPopupForParts !== true) return null
    this.setState({
      selectedBodyPart: props.selectedBodyPart,
      showPopupForParts: props.showPopupForParts === true
    }, () => {
      this.setSelectedProp()
    })
  }
  renderComplaintOrDeviation () {
    // Complaints & Deviation
    if (window.carHandler.priceCalcType !== 5 && window.carHandler.priceCalcType !== 10) return null
    const submit = () => {
      let extents = Object.assign([], this.state.carPartItems)
      let extentsToSubmit = extents.filter((item) => item.IsSelected)
      if (window.carHandler.priceCalcType === 5 || (window.carHandler.priceCalcType === 10 && window.carHandler.realOrderType === 5)) {
        extentsToSubmit.map((item) => {
          item.name = item.id
          item.ComplaintType = item.EnumValue
        })
      }
      let toSubmit = []
      toSubmit.push(extentsToSubmit)
      this.props.setCarSelectedParts(extentsToSubmit)
      this.close()
    }
    const onChange = (e, type) => {
      let { carPartItems } = { ...this.state }
      let item = carPartItems.filter((x) => x.id === e.target.id)[0]
      if (window.carHandler.priceCalcType === 5 || (window.carHandler.priceCalcType === 10 && window.carHandler.realOrderType === 5)) {
        item.IsSelected = !item.IsSelected
      } else {
        if (e.target.name !== 'CustomReason') {
          if (typeof (item.CustomReason) === 'undefined' || (typeof (item.CustomReason) !== 'undefined' && item.CustomReason.length > 0)) item.IsSelected = e.target.checked
        } else {
          if (!item.IsSelected) {
            item.IsSelected = true
            if (carPartItems.indexOf(item) === carPartItems.length - 1) {
              carPartItems.push(this.getBlankDeviation(this.state.selectedBodyPart))
            }
          }
          item[e.target.name] = e.target.value
          if (item.CustomReason.length === 0) {
            item.IsSelected = false
            let lastItem = carPartItems[carPartItems.length - 1]
            if (!lastItem.IsSelected && lastItem.CustomReason === '' && item.id !== lastItem.id) {
              carPartItems.splice(carPartItems.length - 1, 1)
            }
          }
        }
      }
      this.setState({
        carPartItems: carPartItems
      })
    }
    var inputs = this.state.carPartItems
    const renderInputs = (item, key) => {
      var id = item.id
      var isSelected = item.IsSelected
      var isCustom = item.IsCustomDeviation && item.IsNew
      // let checkboxClass = 'carCheckbox__custom'
      // if (isCustom) checkboxClass += ' custom'
      // if (!isCustom) checkboxClass += ' standard'
      // console.log('key', id, item)
      let idKey = '-' + id + '-' + item.IsCustomDeviation + '-' + item.IsNew
      let labelText = (!item.IsCustomDeviation && !item.IsNew) ? item.name : ''
      labelText += (item.IsCustomDeviation && !item.IsNew) ? ' ' + item.CustomReason : ''
      // labelText = isCustom ? <Text size='s' name={'CustomReason'} id={id} value={item.CustomReason} placeholder={translation('227')} onChange={onChange} /> : labelText
      return (
        isCustom ? (
          <Inline alignChildren='center' block>
            <Check simple key={idKey} name={id} id={id} value={id} checked={isSelected} onChange={onChange} />
            <Text size='m' name={'CustomReason'} id={id} value={item.CustomReason} placeholder={translation('227')} onChange={onChange} />
          </Inline>
          ) : <Check key={idKey} labelText={labelText} name={id} id={id} value={id} checked={isSelected} onChange={onChange} />
      )
    }
    return (
      <div>
        {inputs.map(renderInputs)}
        <Divider size={3} noLine />
        <Button onClick={submit} labelText={translation('1208')} />
      </div>
    )
  }
  render () {
    if (this.props.showPopupForParts !== true) return null
    return this.renderComplaintOrDeviation()
  }
  close () {
    this.reset(this.props)
    this.setState({
      carItems: []
    })
    this.props.close()
  }
}
DeviationList.propTypes = {
  close: PropTypes.func.isRequired
}
DeviationList.contextTypes = {
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    price: state.price.price,
    order: state.orders.order,
    showPopupForParts: state.price.showPopupForParts,
    selectedBodyPart: state.price.selectedBodyPart,
    selectedBodyPartSide: state.price.selectedBodyPartSide,
    carItems: state.price.carItems
  }
}

export default connect(mapStateToProps, {
  showPopupParts,
  setCarSelectedParts
})(DeviationList)



// WEBPACK FOOTER //
// ./src/app/shared/components/Car/CarPopup/DeviationList/index.js